<!-- Header Toolbar -->
<mat-toolbar class="app-header-toolbar" color="primary" role="banner">
  
  <!-- Left Section: Menu and Brand -->
  <div class="header-left">
    
    <!-- Mobile Menu Button -->
    <button 
      *ngIf="showMenuButton"
      mat-icon-button 
      class="menu-button"
      (click)="onMenuClick()"
      [attr.aria-label]="'Open navigation menu'"
      [attr.aria-expanded]="false">
      <mat-icon>menu</mat-icon>
    </button>

    <!-- Brand Logo and Name -->
    <div class="brand-container">
      <img 
        src="/assets/images/insee-logo.png" 
        alt="INSEE Logo" 
        class="brand-logo"
        onerror="this.style.display='none'">
      <span class="brand-text">{{ (appName$ | async) || 'INSEE Life Insurance' }}</span>
    </div>
    
  </div>

  <!-- Center Section: Search (Desktop) -->
  <div class="header-center" *ngIf="!showMenuButton">
    
    <mat-form-field class="search-field" appearance="outline">
      <mat-label>Search policies, clients...</mat-label>
      <input 
        matInput 
        type="search"
        placeholder="Type to search..."
        (focus)="onSearchFocus()"
        [attr.aria-label]="'Search application content'">
      <mat-icon matPrefix>search</mat-icon>
      <button mat-icon-button matSuffix [attr.aria-label]="'Clear search'" tabindex="-1">
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>
    
  </div>

  <!-- Right Section: Actions -->
  <div class="header-right">
    
    <!-- Search Button (Mobile) -->
    <button 
      *ngIf="showMenuButton"
      mat-icon-button 
      class="search-button"
      (click)="onSearchFocus()"
      [attr.aria-label]="'Open search'">
      <mat-icon>search</mat-icon>
    </button>

    <!-- Theme Toggle -->
    <button 
      mat-icon-button 
      class="theme-toggle"
      (click)="onThemeToggle()"
      [attr.aria-label]="currentTheme?.isDark ? 'Switch to light theme' : 'Switch to dark theme'"
      [attr.title]="currentTheme?.isDark ? 'Light mode' : 'Dark mode'">
      <mat-icon>{{ currentTheme?.isDark ? 'light_mode' : 'dark_mode' }}</mat-icon>
    </button>

    <!-- Language Switcher -->
    <div class="language-switcher-container">
      <app-language-switcher></app-language-switcher>
    </div>

    <!-- Notifications -->
    <button
      mat-icon-button
      class="notifications-button"
      (click)="onNotificationsClick()"
      [attr.aria-label]="'Open notifications'"
      [matBadge]="(unreadCount$ | async) || null"
      [matBadgeHidden]="!(unreadCount$ | async)"
      matBadgeColor="accent"
      matBadgeSize="small">
      <mat-icon>notifications</mat-icon>
    </button>

    <!-- User Menu -->
    <button 
      mat-icon-button 
      class="user-menu-button"
      (click)="onUserMenuClick()"
      [attr.aria-label]="'Open user menu'"
      [matMenuTriggerFor]="userMenu">
      <mat-icon>account_circle</mat-icon>
    </button>

    <!-- User Menu Dropdown -->
    <mat-menu #userMenu="matMenu" class="user-menu">
      <button mat-menu-item>
        <mat-icon>person</mat-icon>
        <span>Profile</span>
      </button>
      <button mat-menu-item>
        <mat-icon>settings</mat-icon>
        <span>Settings</span>
      </button>
      <mat-divider></mat-divider>
      <button mat-menu-item>
        <mat-icon>help</mat-icon>
        <span>Help & Support</span>
      </button>
      <button mat-menu-item>
        <mat-icon>logout</mat-icon>
        <span>Sign Out</span>
      </button>
    </mat-menu>
    
  </div>

</mat-toolbar>

<!-- Mobile Search Overlay (when needed) -->
<div class="mobile-search-overlay" *ngIf="false">
  <mat-toolbar class="mobile-search-toolbar">
    <button mat-icon-button (click)="false" [attr.aria-label]="'Close search'">
      <mat-icon>arrow_back</mat-icon>
    </button>
    <mat-form-field class="mobile-search-field" appearance="fill">
      <input 
        matInput 
        type="search"
        placeholder="Search..."
        [attr.aria-label]="'Search application content'">
    </mat-form-field>
  </mat-toolbar>
</div>